import { styled } from "styled-components";

// Styled components
export const TermsBox = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.border || '#C4C4C4'};
  border-radius: 10px;
  padding: 8px;
  background-color: ${({ theme }) => theme.colors.background || '#FFF'};
  color: #7C7C7C;
  max-height: calc(100vh - 255px);
  overflow-y: auto;
  
  @media (max-width: 375px) {
    max-height: calc(100vh - 280px);
  }
`;

export const Title = styled.h1`
  font-size: 32px;
  font-weight: 500;
  margin-bottom: 16px;
`;

export const Subtitle = styled.h2`
  font-size: 24px;
  font-weight: 500;
  margin: 24px 0 16px;
`;

export const Paragraph = styled.p`
  margin-bottom: 16px;
  line-height: 1.5;
`;

export const ListItem = styled.div`
  margin-bottom: 8px;
  padding-left: 8px;
`;

export const Section = styled.div`
  margin-top: 32px;
`;

export const Container = styled.div`
  // margin-bottom: 16px;
`;

export const AgreementContainer = styled.div`
  margin: 16px 0;
  padding: 0 16px;
`;

export const ErrorMessage = styled.span`
  display: block;
  color: ${({ theme }) => theme.colors.error || '#f44336'};
  font-size: 13px;
  font-weight: 700;
  margin-top: 8px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
  padding: 0 16px;
  gap: 16px;
`;

export const BackButton = styled.button`
  padding: 12px 24px;
  border: 1px solid ${({ theme }) => theme.colors.primary || '#4F2D7F'};
  border-radius: 8px;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.primary || '#4F2D7F'};
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  min-width: 120px;
  transition: all 0.3s ease;

  &:hover {
    background-color: rgba(79, 45, 127, 0.1);
  }
`;

export const NextButton = styled.button`
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.primary || '#4F2D7F'};
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  min-width: 120px;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryDark || '#3a1f5e'};
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;